var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 106.62 80",
    style: {
      enableBackground: "new 0 0 106.62 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b61f689e",
    d: "M106.57,38.73c-0.07,0-2.47-0.15-2.47-0.15c-9.75-0.73-9.54-9.54-9.54-9.54C94.7,18.2,88.52,1.02,64.2,0     H22.13l-0.58,2.11h35.3c3.57,0.07,6.11,2.69,4.88,6.92l-6.33,23c-2.4,6.92-8.74,6.55-8.74,6.55C40.18,38,42,31.88,42,31.88     l2.91-10.56c0.87-3.57-1.6-5.24-3.86-5.31H17.69l-0.58,2.11h9.97c3.64,0.07,4.44,2.84,3.79,5.31c0,0-1.24,4.37-2.69,9.83     c-1.46,5.31-6.33,5.46-7.06,5.46h-9.75L10.7,41.2h9.24c1.09,0,6.04,0.22,4.59,5.53c-1.53,5.53-2.69,9.83-2.69,9.83     c-0.73,2.47-2.98,5.17-6.77,5.31H5.02l-0.58,2.11h23.37c2.26-0.07,5.75-1.75,6.84-5.39l2.91-10.48c0,0,1.53-6.19,8.3-6.7     c0,0,6.55-0.36,5.1,6.55l-6.33,23c-1.16,4.29-5.1,6.92-8.74,6.92H0.58L0,80h42.15c24.9-1.02,40.55-18.27,46.37-29.04     c0,0,4.66-8.81,14.78-9.54l2.47-0.15c0,0,0.15,0,0.22-0.15c0.15-0.44,0.58-2.11,0.58-2.18C106.72,38.8,106.64,38.73,106.57,38.73     ",
    fill: "#002856"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M22.13,0l-0.58,2.11h35.3c3.57,0.07,6.11,2.69,4.88,6.92l-6.33,23c-2.4,6.92-8.74,6.55-8.74,6.55       C40.18,38,42,31.88,42,31.88l2.91-10.56c0.87-3.57-1.6-5.24-3.86-5.31H17.69l-0.58,2.11h9.97c3.64,0.07,4.44,2.84,3.79,5.31       c0,0-1.24,4.37-2.69,9.83c-1.46,5.31-6.33,5.46-7.06,5.46h-9.75L10.7,41.2h9.24c1.09,0,6.04,0.22,4.59,5.53       c-1.53,5.53-2.69,9.83-2.69,9.83c-0.73,2.47-2.98,5.17-6.77,5.31H5.02l-0.58,2.11h23.37c2.26-0.07,5.75-1.75,6.84-5.39       l2.91-10.48c0,0,1.53-6.19,8.3-6.7c0,0,6.55-0.36,5.1,6.55l-6.33,23c-1.16,4.29-5.1,6.92-8.74,6.92H0.58L0,80h42.15       c24.9-1.02,40.55-18.2,46.37-29.04c0,0,4.66-8.81,14.78-9.54l2.47-0.15c0,0,0.15,0,0.22-0.15c0.15-0.44,0.58-2.11,0.58-2.18       c0-0.07,0-0.15-0.07-0.15s-2.47-0.15-2.47-0.15c-9.75-0.73-9.54-9.54-9.54-9.54c0.15-10.77-6.04-28.03-30.35-29.04h-42V0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142867267191542898240000004387362384649669801_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 9.54,
    y: -2.04,
    style: {
      clipPath: "url(#SVGID_00000142867267191542898240000004387362384649669801_)",
      fill: "#DB0F18"
    },
    width: 98.78,
    height: 42
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMh);
export default __webpack_public_path__ + "static/media/MH.4060841f2fbb8336e193d172e24212ec.svg";
export { ForwardRef as ReactComponent };